document.addEventListener("DOMContentLoaded", async () => {

    if (!window.location.pathname.includes("/products/sea-buckthorn-omega-3-6-7-9-oil-capsule-30-capsule")) {
  return; // ❌ Exit for all other product pages
}

  const cards = document.querySelectorAll(".pricing-card");
  const buyBtn = document.getElementById("buyNowBtn");
  const snackbar = document.getElementById("snackbar");
  let selectedCard = cards[1]; // ✅ Preselect 2nd variant immediately
  if (selectedCard) selectedCard.classList.add("active", "yellow-bg");
  // 🔥 Sync default variant to Shopify real form
  const mainVariantInput = document.querySelector("input[name='id']");
  if (mainVariantInput && selectedCard) {
    mainVariantInput.value = selectedCard.dataset.variantId;
  }


  // === Fetch Prices for Each Variant ===
  for (const card of cards) {
    const variantId = card.dataset.variantId;
    try {
      const res = await fetch(`/variants/${variantId}.js`);
      const variant = await res.json();

      // Format the prices
      const price = `₹${Math.round(variant.price / 100).toLocaleString("en-IN")}`;

      const compare = variant.compare_at_price
        ? `₹${Math.round(variant.compare_at_price / 100).toLocaleString("en-IN")}`
        : "";

      // Insert prices into the correct card
      const priceEl = card.querySelector(".price-text");
      if (priceEl) {
        priceEl.innerHTML = `
  ${price}
  ${compare ? `<span class="old-price">${compare}</span>` : ""}
`;
      }
    } catch (err) {
      console.warn("Failed to fetch variant:", variantId, err);
    }
  }


  // === Variant Selection ===
  cards.forEach(card => {
    card.addEventListener("click", () => {
      cards.forEach(c => c.classList.remove("active", "yellow-bg"));
      card.classList.add("active", "yellow-bg");
      selectedCard = card;

      // 🔥 Sync clicked variant to Shopify real form
      const mainVariantInput = document.querySelector("input[name='id']");
      if (mainVariantInput) {
        mainVariantInput.value = card.dataset.variantId;
      }
    });
  });


  // === Add to Cart Function ===
  async function addToCart(variantId, quantity = 1, properties = {}) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity, properties }),
    });
    if (!res.ok) throw new Error("Add to cart failed");
    return res.json();
  }

  // === Add Product + Freebie ===
  buyBtn.addEventListener("click", async (e) => {
  e.preventDefault();
  e.stopPropagation();
    if (!selectedCard) {
      selectedCard = cards[1];
      selectedCard.classList.add("active", "yellow-bg");
    }

    const variantId = selectedCard.dataset.variantId;
    

    buyBtn.disabled = true;
    buyBtn.textContent = "Adding...";

    try {
      await addToCart(variantId, 1);
      


      snackbar.classList.add("show");
      setTimeout(() => {
  snackbar.classList.remove("show");

  // ✅ Open Shopflo cart drawer
  if (typeof handleFloCartBtn === "function") {
    handleFloCartBtn();
  } else {
    console.warn("Shopflo cart function not found");
  }

}, 300);

    } catch (err) {
      console.error(err);
      snackbar.textContent = "Error adding to cart!";
      snackbar.classList.add("show");
      setTimeout(() => snackbar.classList.remove("show"), 2000);
    } finally {
      buyBtn.disabled = false;
      buyBtn.textContent = "BUY NOW";
    }
  });
});















document.addEventListener("DOMContentLoaded", () => {
  const stickySection = document.querySelector(".pricing-containerr.sticky-bottom");
  if (!stickySection) return;

  // how far to scroll before showing sticky section (in px)
  const triggerHeight = 2000; // you can adjust this (e.g. 400-800)

  function toggleStickyVisibility() {
    if (window.scrollY > triggerHeight) {
      stickySection.classList.add("visible");
    } else {
      stickySection.classList.remove("visible");
    }
  }

  window.addEventListener("scroll", toggleStickyVisibility);
});


document.addEventListener("DOMContentLoaded", () => {
  const stickyBtn = document.querySelector(".pricing-containerr.sticky-bottom .add-cart-btn");
  const mainBuyBtn = document.querySelector("#buyNowBtn"); // main Buy Now button

  if (stickyBtn && mainBuyBtn) {
    let isProcessing = false; // prevent double-tap issues

    stickyBtn.addEventListener("click", (e) => {
      e.preventDefault();

      if (isProcessing) return; // ignore duplicate clicks
      isProcessing = true;

      stickyBtn.classList.add("clicked"); // optional visual feedback
      console.log("✅ Sticky BUY NOW triggered");

      // Trigger the main Buy Now click with no delay
      mainBuyBtn.click();

      // re-enable after short lock to prevent duplicate add-to-cart
      setTimeout(() => {
        isProcessing = false;
        stickyBtn.classList.remove("clicked");
      }, 300);
    });
  }
});










document.addEventListener("DOMContentLoaded", async () => {
  const stickyContainer = document.querySelector(".pricing-containerr.sticky-bottom");
  if (!stickyContainer) return;

  const cards = stickyContainer.querySelectorAll(".pricing-card");
  const buyBtn = stickyContainer.querySelector("#mobileBuyNow");
  const mainBuyBtn = document.querySelector("#buyNowBtn");

  

  // === Fetch & Display Prices ===
  for (const card of cards) {
    const variantId = card.dataset.variantId;
    try {
      const res = await fetch(`/variants/${variantId}.js`);
      const variant = await res.json();

      const price = `₹${Math.round(variant.price / 100).toLocaleString("en-IN")}`;

      const compare = variant.compare_at_price
        ? `₹${Math.round(variant.compare_at_price / 100).toLocaleString("en-IN")}`
        : "";

      const priceEl = card.querySelector(".price-text");
      if (priceEl) {
        priceEl.innerHTML = `
  ${price}
  ${compare ? `<span class="old-price">${compare}</span>` : ""}
`;
      }
    } catch (err) {
      console.warn("Failed to fetch variant:", variantId, err);
    }
  }

  // === Default Selection (2nd Variant) ===
  let selectedCard = null;
  function activateDefaultVariant() {
    cards.forEach(c => c.classList.remove("active"));
    if (cards[1]) {
      selectedCard = cards[1];
      selectedCard.classList.add("active");
      addCheckmark(selectedCard);
      selectedCard.scrollIntoView({ inline: "center", behavior: "smooth" });

      // 🔥 Correct place: sync sticky default to Shopify form
      const mainVariantInput = document.querySelector("input[name='id']");
      if (mainVariantInput) {
        mainVariantInput.value = selectedCard.dataset.variantId;
      }
    }
  }




  // Run once when loaded and again after prices finish loading
  activateDefaultVariant(); // runs immediately, no delay


  // === Add checkmark dynamically ===
  function addCheckmark(card) {
    cards.forEach(c => {
      const existing = c.querySelector(".checkmark");
      if (existing) existing.remove();
    });
    const tick = document.createElement("div");
    tick.classList.add("checkmark");
    tick.innerHTML = "✔";
    tick.style.cssText = `
  position: absolute;
  top: -9px;
  right: -5px;
  background: #ff7a00;
  color: #fff;
  border-radius: 50%;
  font-size: 11px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  `;
    card.style.position = "relative";
    card.appendChild(tick);
  }

  // === Variant Selection Logic ===
  cards.forEach(card => {
    card.addEventListener("click", () => {
      cards.forEach(c => c.classList.remove("active"));
      card.classList.add("active");
      selectedCard = card;
      addCheckmark(card);
    });
  });

  // === Buy Now mirrors main button ===
  if (buyBtn && mainBuyBtn) {
    buyBtn.addEventListener("click", () => {
      if (selectedCard) {
        const variantId = selectedCard.dataset.variantId;

        // Set same selection on main cards (sync)
        document.querySelectorAll(".pricing-card").forEach(c => c.classList.remove("active"));
        const mainCard = document.querySelector(`.pricing-card[data-variant-id='${variantId}']`);
        if (mainCard) mainCard.classList.add("active");

        console.log("Sticky Buy clicked → Variant:", variantId);
      }
      mainBuyBtn.click();
    });
  }

  // === Show Sticky Bar on Scroll ===
  const triggerHeight = 2000;
  window.addEventListener("scroll", () => {
    if (window.scrollY > triggerHeight) {
      stickyContainer.classList.add("visible");
    } else {
      stickyContainer.classList.remove("visible");
    }
  });
});


























// ===============================
// AUTOPLAY MUTED VIDEOS
// ===============================
document.querySelectorAll(".carousel-video").forEach(video => {
  video.play().catch(() => { });
});

// ===============================
// RIGHT ARROW SCROLL
// ===============================
const videoCarousel = document.getElementById("videoCarousel");
const rightArrow = document.getElementById("rightArrow");

rightArrow.addEventListener("click", () => {
  videoCarousel.scrollBy({
    left: 300,
    behavior: "smooth"
  });
});

// ===============================
// POPUP LOGIC (FIXED)
// ===============================
const popup = document.getElementById("videoPopup");
const closePopup = document.getElementById("closePopup");

// Open popup on card click
document.querySelectorAll(".video-card").forEach(card => {
  card.addEventListener("click", function () {

    const originalVideo = this.querySelector("video");

    // Clone video (keeps buffer)
    let cloned = originalVideo.cloneNode(true);
    cloned.id = "popupVideo";
    cloned.muted = false;
    cloned.controls = true;

    // Replace popup video
    const oldPopupVideo = document.getElementById("popupVideo");
    oldPopupVideo.replaceWith(cloned);

    // Show popup (CSS based)
    popup.classList.add("active");

    // Play video smoothly
    setTimeout(() => {
      cloned.play().catch(() => { });
    }, 50);
  });
});

// Close popup
closePopup.addEventListener("click", () => {
  const vid = document.getElementById("popupVideo");
  vid.pause();
  popup.classList.remove("active");
});

// Close popup when clicking outside the video
popup.addEventListener("click", (e) => {
  if (e.target === popup) {
    const vid = document.getElementById("popupVideo");
    vid.pause();
    popup.classList.remove("active");
  }
});

// ===============================
// MOUSE DRAG SCROLL
// ===============================
let isDown = false;
let startX;
let scrollLeft;

videoCarousel.addEventListener("mousedown", (e) => {
  isDown = true;
  videoCarousel.classList.add("active");
  startX = e.pageX - videoCarousel.offsetLeft;
  scrollLeft = videoCarousel.scrollLeft;
});

videoCarousel.addEventListener("mouseleave", () => {
  isDown = false;
  videoCarousel.classList.remove("active");
});

videoCarousel.addEventListener("mouseup", () => {
  isDown = false;
  videoCarousel.classList.remove("active");
});

videoCarousel.addEventListener("mousemove", (e) => {
  if (!isDown) return;
  e.preventDefault();
  const x = e.pageX - videoCarousel.offsetLeft;
  const walk = (x - startX) * 2;
  videoCarousel.scrollLeft = scrollLeft - walk;
});


// Frequently Bought Together

document.addEventListener("DOMContentLoaded", function () {

  // Select all FBT product boxes
  const fbtBoxes = document.querySelectorAll(".fbt-box");

  fbtBoxes.forEach(box => {
    const priceElem = box.querySelector(".fbt-price");
    const compareElem = box.querySelector(".fbt-compare");
    const offElem = box.querySelector(".fbt-off");
    const addBtn = box.querySelector(".fbt-add-btn");

    const variantId = priceElem.dataset.variant;

    /* --------------------------
       FETCH LIVE PRICE
    --------------------------- */
    fetch(`/variants/${variantId}.js`)
      .then(res => res.json())
      .then(variant => {
        const price = variant.price / 100;
        const compare = variant.compare_at_price ? variant.compare_at_price / 100 : null;
        const discountPercent = compare ? Math.round(((compare - price) / compare) * 100) : 0;

        priceElem.textContent = `₹${price.toLocaleString("en-IN")}`;

        if (compareElem && compare) {
          compareElem.textContent = `₹${compare.toLocaleString("en-IN")}`;
        }

        if (offElem && compare) {
          offElem.textContent = `${discountPercent}% OFF`;
        }
      })
      .catch(err => console.error("Price fetch error:", err));


    /* --------------------------
       AJAX ADD TO CART
    --------------------------- */
    addBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      // If already added → open Shopflo cart
if (addBtn.dataset.state === "added") {
  if (typeof handleFloCartBtn === "function") {
    handleFloCartBtn();
  }
  return;
}


      addBtn.disabled = true;
      addBtn.innerText = "Adding...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(res => res.json())
        .then(() => {
          addBtn.dataset.state = "added";
          addBtn.innerText = "VIEW CART";
          addBtn.disabled = false;
          addBtn.classList.add("added-to-cart");
if (typeof handleFloCartBtn === "function") {
  handleFloCartBtn();
}

          // ⭐ Show "Added to cart" message
          const statusMsg = box.querySelector(".fbt-status-msg");
          if (statusMsg) {
            statusMsg.style.display = "block";
            statusMsg.innerText = "Added to cart!";

            setTimeout(() => {
              statusMsg.style.display = "none";
            }, 3000);

          }
        })
        .catch(err => { console.error("Cart error:", err); addBtn.innerText = "ADD TO CART"; addBtn.disabled = false; });
    });
  });
});

// Frequently Bought Together


document.querySelectorAll(".pricing-card").forEach(async card => {
  const variantId = card.dataset.variantId;
  const saveBadge = card.querySelector(".save-badge");

  if (!variantId || !saveBadge) return;

  try {
    const res = await fetch(`/variants/${variantId}.js`);
    const variant = await res.json();

    // If no compare price → hide badge
    if (!variant.compare_at_price) {
      saveBadge.style.display = "none";
      return;
    }

    const price = Math.round(variant.price / 100);
    const mrp = Math.round(variant.compare_at_price / 100);

    if (mrp > price) {
      saveBadge.innerText = `Save ₹${mrp - price}`;
      saveBadge.style.display = "inline-block";
    } else {
      saveBadge.style.display = "none";
    }

  } catch (err) {
    console.error("Save badge error:", err);
  }
});

